import React, { useState, useEffect, useCallback } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const n = TESTIMONIALS.length;
  const go = useCallback((d) => setI((p) => (p + d + n) % n), [n]);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % n), 6000);
    return () => clearInterval(t);
  }, [n]);

  const t = TESTIMONIALS[i];

  return (
    <section id="testimonials" className="relative overflow-hidden bg-white py-24 sm:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1000px] px-5 text-center sm:px-8">
        <Reveal><div className="flex justify-center"><Overline>What Clients Say</Overline></div></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-6 max-w-2xl font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Trusted by leaders across <span className="text-gradient-emerald">complex sectors</span>.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative mt-14 rounded-[2rem] border border-black/5 bg-bg-light p-8 card-shadow sm:p-14">
            <Quote size={48} className="mx-auto text-gold" fill="currentColor" />
            <blockquote key={i} className="mx-auto mt-6 max-w-2xl animate-[fadeIn_0.6s_ease] font-serif text-2xl font-light leading-snug text-charcoal sm:text-3xl" data-testid="testimonial-quote">
              “{t.quote}”
            </blockquote>
            <div className="mt-8">
              <p className="text-sm font-bold uppercase tracking-wider text-emerald-base">{t.role}</p>
              <p className="text-sm text-charcoal/50">{t.sector}</p>
            </div>

            <div className="mt-8 flex items-center justify-center gap-4">
              <button onClick={() => go(-1)} data-testid="testimonial-prev" aria-label="Previous testimonial"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-black/10 text-charcoal/60 transition-colors hover:border-gold hover:text-gold">
                <ChevronLeft size={18} />
              </button>
              <div className="flex gap-2">
                {TESTIMONIALS.map((_, idx) => (
                  <button key={idx} onClick={() => setI(idx)} aria-label={`Testimonial ${idx + 1}`}
                    className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-6 bg-gold" : "w-2 bg-black/15 hover:bg-black/30"}`} />
                ))}
              </div>
              <button onClick={() => go(1)} data-testid="testimonial-next" aria-label="Next testimonial"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-black/10 text-charcoal/60 transition-colors hover:border-gold hover:text-gold">
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
